import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DupontButton from "../../components/DupontButton";
import { storeAccessUserPlant } from "../../Store/TemplateStore/template.action";
import { updatePlantId } from "../../utils/Utils";
import { API_URLS } from "../../network/appUrls";

const ViewPlantCellRenderer = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data } = props;
  const { t } = useTranslation();
  const basePath = API_URLS.basePath;

  const handleViewPlant = () => {
    updatePlantId(data.plant_id);
    dispatch(storeAccessUserPlant(true));
    const path = `${basePath}editPlant?plantId=${data.plant_id}&isEdit=true`;
    navigate(path, { state: { noOfTrains: data.num_trains } });
  };

  return (
    <DupontButton onClick={handleViewPlant} type="primary">
      {t("addNewPlant.viewPlants")}
    </DupontButton>
  );
};

export default ViewPlantCellRenderer;
